<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ lang('Đổi mật khẩu') }}: {{ user.name }}
      </p>
    </header>
    <section class="modal-card-body">
      <form @submit.prevent="save">
        <b-field :label="lang('New password')" :type="loi ? 'is-danger' : ''" :message="loi">
          <b-input v-model="matKhauMoi" password-reveal required @keydown.native="loi = ''" />
        </b-field>
      </form>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ lang('Close') }}
      </button>
      <button class="button is-primary" type="button" :class="{ 'is-loading': dangLuu }" @click="save">
        {{ lang('Save') }}
      </button>
    </footer>
  </div>
</template>

<script>
import api from '../../api/api'

// Quản trị viên đặt lại mật khẩu cho một người dùng khác: không cần mật khẩu cũ. Gửi lại nguyên
// thông tin hiện có của người đó, chỉ thêm mật khẩu mới (API updateuser yêu cầu đủ các trường).
export default {
  name: 'DoiMatKhau',
  props: ['user'],
  data() {
    return {
      matKhauMoi: '',
      loi: '',
      dangLuu: false,
    }
  },
  methods: {
    save() {
      if (!this.matKhauMoi) {
        this.loi = this.lang('This field is required')
        return
      }
      this.dangLuu = true
      api.updateUser({
        key: this.user.username,
        role: this.user.role,
        name: this.user.name,
        username: this.user.username,
        homedir: this.user.homedir,
        permissions: this.user.permissions,
        password: this.matKhauMoi,
      })
        .then(() => {
          this.dangLuu = false
          this.$toast.open({
            message: this.lang('Updated'),
            type: 'is-success',
          })
          this.$parent.close()
        })
        .catch(error => {
          this.dangLuu = false
          this.handleError(error)
        })
    },
  },
}
</script>
